import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.products || initialState;

const makeSelectList = () =>
  createSelector(select, subState => subState.productsList);
const makeSelectVitrinList = () =>
  createSelector(select, subState => subState.vitrinProductsList);
const makeSelectVitrinCount = () =>
  createSelector(select, subState => subState.vitrinProductsCount);

const makeSelectCategoriesList = () =>
  createSelector(select, subState => subState.categoriesList);

const makeSelectProduct = () =>
  createSelector(select, subState => subState.product);

const makeSelectVariant = () =>
  createSelector(select, subState => subState.variant);

const makeSelectVariantFeaturesListByProductId = () =>
  createSelector(select, subState => subState.variantFeaturesList);

const makeSelectProductsVariantListByProductId = () =>
  createSelector(select, subState => subState.productVariantList);

const makeSelectAllList = () =>
  createSelector(select, subState => subState.allProductsList);

const makeSelectProductsInventoryListByProductId = () =>
  createSelector(select, subState => subState.productsInventoryList);

const makeSelectUsersListByCenterId = () =>
  createSelector(select, subState => subState.usersByCenterId);

const makeSelectUsersListBeCenter = () =>
  createSelector(select, subState => subState.usersBeAdminCenter);

const makeSelectCenter = () =>
  createSelector(select, subState => subState.product);

const makeSelectProductsVariantListCount = () =>
  createSelector(select, subState => subState.productVariantListCount);

const makeSelectCountList = () =>
  createSelector(select, subState => subState.count);

const makeSelectVariantInventoryItemsList = () =>
  createSelector(select, subState => subState.productVariantInventoryItemsList);

const makeSelectVariantInventoryItemsCount = () =>
  createSelector(
    select,
    subState => subState.productVariantInventoryItemsListCount
  );

const makeSelectLoading = () =>
  createSelector(select, subState => subState.loading);

const makeSelectAllListLoading = () =>
  createSelector(select, subState => subState.allProductsListLoading);

const makeSelectCategoryLoading = () =>
  createSelector(select, subState => subState.categoryLoading);

const makeSelectError = () =>
  createSelector(select, subState => subState.error);

const makeSelectPartnerCategories = () =>
  createSelector(select, subState => subState.partnerCategoriesList);

export default select;
export {
  makeSelectList,
  makeSelectProduct,
  makeSelectCenter,
  makeSelectLoading,
  makeSelectCategoryLoading,
  makeSelectCountList,
  makeSelectError,
  makeSelectUsersListByCenterId,
  makeSelectUsersListBeCenter,
  makeSelectProductsInventoryListByProductId,
  makeSelectProductsVariantListByProductId,
  makeSelectAllList,
  makeSelectVariant,
  makeSelectCategoriesList,
  makeSelectProductsVariantListCount,
  makeSelectVariantFeaturesListByProductId,
  makeSelectVariantInventoryItemsList,
  makeSelectVariantInventoryItemsCount,
  makeSelectPartnerCategories,
  makeSelectAllListLoading,
  makeSelectVitrinList,
  makeSelectVitrinCount,
};
